import React from 'react';
import FieldWithLabel from '../../../../../../Components/FieldWithLabel/FieldWithLabel';
import { Inputs } from '../../../../../../Components';

export default function SLAConfigurationFields({
  translate,
  parentTranslationPath,
  slaConfigurationData,
  setSlaConfigurationData,
}) {
  return (
    <div>
      <FieldWithLabel
        label={translate('Max reassignments')}
        subLabel={'Times a lead can be reassigned'}
        hideDivider
        component={
          <Inputs
            type='number'
            wrapperClasses={'w-50'}
            idRef='valueRef'
            inputPlaceholder={'enter'}
            fieldClasses='fields-content'
            parentTranslationPath={parentTranslationPath}
            value={slaConfigurationData?.maxReassignmentsAllowed}
            onInputChanged={(e) => {
              const newValue = e.target.value;
              setSlaConfigurationData({
                ...slaConfigurationData,
                maxReassignmentsAllowed: newValue,
              });
            }}
          />
        }
      />
      <FieldWithLabel
        label={translate('Inactivity duration threshold')}
        subLabel={'Max days lead can be untouched'}
        component={
          <Inputs
            type='number'
            wrapperClasses={'w-50'}
            idRef='valueRef'
            inputPlaceholder={'Days (e.g., 20)'}
            fieldClasses='fields-content'
            parentTranslationPath={parentTranslationPath}
            value={slaConfigurationData?.inactivityThresholdInDays}
            onInputChanged={(e) => {
              const newValue = e.target.value;
              setSlaConfigurationData({
                ...slaConfigurationData,
                inactivityThresholdInDays: newValue,
              });
            }}
          />
        }
      />
    </div>
  );
}
